<template>
    <svg
        alt="Facebook"
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="M13.312 9.997V8.433c0-.681.15-1.047 1.26-1.047h1.363V4.75H13.84c-2.636 0-3.682 1.728-3.682 3.683v1.576H8.065v2.61h2.094v7.631h3.14v-7.63h2.308l.315-2.623H13.3h.013Z" fill="currentColor"/>
    </svg>
</template>
